'use strict';

/**
 * A collection of functions useful when creating calendar layouts
 * 
 */

(function () {
  'use strict';

  angular.module('msUtility').factory('calUtilities', calendarUtilities);

  function calendarUtilities() {
    var _marked = /*#__PURE__*/regeneratorRuntime.mark(generateDay),
        _marked2 = /*#__PURE__*/regeneratorRuntime.mark(dayCssClasses),
        _marked3 = /*#__PURE__*/regeneratorRuntime.mark(generateDaysOfWeek);

    return {
      generateDaysOfWeek: generateDaysOfWeek,
      generateDay: generateDay,
      dayCssClasses: dayCssClasses
    };

    // Generate each day. Keeps going until it reaches endDate. Yields an object used to display a day.    
    function generateDay(startDate, endDate) {
      var date;
      return regeneratorRuntime.wrap(function generateDay$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              date = moment(startDate);

            case 1:
              if (!date.isSameOrBefore(moment(endDate))) {
                _context.next = 7;
                break;
              }

              _context.next = 4;
              return {
                date: angular.copy(date),
                isToday: date.isSame(moment().subtract(1, 'day'), 'day'),
                isFuture: date.isAfter(moment().subtract(1, 'day'), 'day')
              };

            case 4:
              date.add(1, 'day');
              _context.next = 1;
              break;

            case 7:
            case 'end':
              return _context.stop();
          }
        }
      }, _marked, this);
    }

    // Given a day, returns an array of classes to apply with ngClass.
    // Can be used in a template as:
    // $ctrl.applyClasses = d => [...calUtilities.dayCssClasses(d)];
    // <element ng-class="$ctrl.applyClasses(dayObject)" />
    function dayCssClasses(day) {
      var key;
      return regeneratorRuntime.wrap(function dayCssClasses$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.t0 = regeneratorRuntime.keys(day);

            case 1:
              if ((_context2.t1 = _context2.t0()).done) {
                _context2.next = 8;
                break;
              }

              key = _context2.t1.value;

              if (!(day[key] === true)) {
                _context2.next = 6;
                break;
              }

              _context2.next = 6;
              return _.kebabCase(key);

            case 6:
              _context2.next = 1;
              break;

            case 8:
            case 'end':
              return _context2.stop();
          }
        }
      }, _marked2, this);
    }

    // Generate each weekday name in a calendar week.
    function generateDaysOfWeek() {
      var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, d;

      return regeneratorRuntime.wrap(function generateDaysOfWeek$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _iteratorError = undefined;
              _context3.prev = 3;
              _iterator = Array(7).keys()[Symbol.iterator]();

            case 5:
              if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                _context3.next = 12;
                break;
              }

              d = _step.value;
              _context3.next = 9;
              return moment().weekday(d);

            case 9:
              _iteratorNormalCompletion = true;
              _context3.next = 5;
              break;

            case 12:
              _context3.next = 18;
              break;

            case 14:
              _context3.prev = 14;
              _context3.t0 = _context3['catch'](3);
              _didIteratorError = true;
              _iteratorError = _context3.t0;

            case 18:
              _context3.prev = 18;
              _context3.prev = 19;

              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }

            case 21:
              _context3.prev = 21;

              if (!_didIteratorError) {
                _context3.next = 24;
                break;
              }

              throw _iteratorError;

            case 24:
              return _context3.finish(21);

            case 25:
              return _context3.finish(18);

            case 26:
            case 'end':
              return _context3.stop();
          }
        }
      }, _marked3, this, [[3, 14, 18, 26], [19,, 21, 25]]);
    }
  }
})();